import React, { Dispatch } from 'react';
import axios from 'ps-components/lib/apiClient';
import { List } from '../../../../../components/common/List';
import { ReportInspectorAction, ReportInspectorState } from '../store';
import { useSearchParams } from '../../../../../hooks/util';
import { useQuery } from 'react-query';

interface ReportFieldsProps {
  report: any;
  state: ReportInspectorState
  dispatch: Dispatch<ReportInspectorAction>
}

const columns = [
  { label: 'Order', field: 'column_order' },
  { label: 'Report Field PK', field: 'report_field_pk' },
  { label: 'Field PK', field: 'field_pk' },
  { label: 'Old Field PK', field: 'old_field_pk' },
  { label: 'Default Title', field: 'default_title' },
  { label: 'Override Label', field: 'override_label' },
  { label: 'Display on Results', field: 'display_on_results', format: (field: string | boolean) => !!field ? 'True' : 'False' },
  { label: 'Group By', field: 'group_by' },
  { label: 'Source Field', field: 'source_field' },
  { label: 'Table Name', field: 'table_name' },
  { label: 'Formula PK', field: 'formula_pk' },
  { label: 'Metadata', field: 'metadata', format: (field: Object) => JSON.stringify(field) },
  { label: 'Field Type Name', field: 'field_type_name' },
  { label: 'Field Type Code', field: 'field_type_code' },
  { label: 'Report Field Metadata', field: 'report_field_metadata' }
];

const ReportFields: React.FC<ReportFieldsProps> = ({ report, dispatch }) => {
  const { setSearchParams } = useSearchParams()

  const fetchFields = async () => {
    if (!report) return
    try {
      const response = await axios.apiGet(`/api/marketpay-internal/report-inspector/reportFields?reportPk=${report.report_pk}`);

      return response.data.fields;
    } catch (error) {
      console.error(error);
      return []
    }
  };


  const { data: fields } = useQuery(['fields', { reportPk: report.report_pk }], fetchFields)

  const handleSelect = (row: Record<string, string>) => {
    if (!!row.formula_pk) {
      dispatch({ type: 'selectAndViewFormula', payload: Number(row.formula_pk) })
      setSearchParams({ reportTab: 'formulas', formulaPk: row.formula_pk })
    }
  }

  if (!fields) return <></>

  return (
    <List
      data={fields}
      dataCount={0}
      uniqueKey='field_pk'
      columns={columns}
      handleSelect={handleSelect}
    />
  )
};

export default ReportFields;
